/// FOURJS_START_COPYRIGHT(D,2023)
/// Property of Four Js*
/// (c) Copyright Four Js 2023, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT
"use strict";

modulum("RowAspect4STBehavior", ["StyleBehaviorBase"], function (context, cls) {
  /**
   * @class RowAspect4STBehavior
   * @memberof classes
   * @extends classes.StyleBehaviorBase
   */
  cls.RowAspect4STBehavior = context.oo.Singleton(cls.StyleBehaviorBase, function ($super) {
    return /** @lends classes.RowAspect4STBehavior */ {
      __name: "RowAspect4STBehavior",

      usedStyleAttributes: ["rowAspect"],

      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const widget = controller.getWidget();
        const node = controller.getAnchorNode();
        let rowAspect = node.getStyleAttribute("rowAspect");

        // Deprecated ListView falls back to flipped list
        if (node.getTag() === "Table" && node.isListView()) {
          rowAspect = "list";
        }

        widget.getRowAspectComponent().setRowAspect(rowAspect);
      }
    };
  });
});
